/**
 * The built-in apps' icons: one set, drawn on a 24px grid as 1.75px rounded
 * strokes in currentColor, so they sit on a tab label, a launcher tile (white
 * on the item's colour) and the compliance rail alike.
 *
 * ComplianceRail.ts carries an identical copy (the content script cannot
 * import the React app); workspaceIcons.test.js fails if the two drift.
 */
export const WORKSPACE_ICONS = {
  note:
    '<path d="M7 3h7l5 5v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>' +
    '<path d="M14 3v5h5"/><path d="M8.5 13h7M8.5 16.5h4.5"/>',
  // Ask (COM-326): a chat bubble with sparkles.
  chat:
    '<path d="M13 4H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h1v3l4-3h5a2 2 0 0 0 2-2v-3"/>' +
    '<path d="M8 9h4M8 12h6"/>' +
    '<path d="M18.5 2.5l.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9z"/>' +
    '<path d="M20.5 15.5l.5 1.1 1.1.5-1.1.5-.5 1.1-.5-1.1-1.1-.5 1.1-.5z"/>',
  // A shield with a check: protected, documentation that holds up.
  compliance:
    '<path d="M12 3 4.5 6v5.6c0 4.5 3.1 8.1 7.5 9.4 4.4-1.3 7.5-4.9 7.5-9.4V6Z"/>' +
    '<path d="m8.8 12.2 2.3 2.3 4.2-4.6"/>',
  summary:
    '<path d="M4 7h8M4 12h10M4 17h7"/>' +
    '<path d="M18 3.5 19 6l2.5 1-2.5 1-1 2.5-1-2.5-2.5-1 2.5-1Z"/>',
  // Billing codes: $$.
  coding:
    '<path d="M10 8.4c-.4-1.3-1.6-2.1-3-2.1-1.8 0-3 1-3 2.4 0 3.2 6 1.9 6 5.3 0 1.5-1.3 2.5-3.1 2.5-1.5 0-2.7-.8-3.1-2.1M7 4.3v2M7 16.3v2.2M20 8.4c-.4-1.3-1.6-2.1-3-2.1-1.8 0-3 1-3 2.4 0 3.2 6 1.9 6 5.3 0 1.5-1.3 2.5-3.1 2.5-1.5 0-2.7-.8-3.1-2.1M17 4.3v2M17 16.3v2.2"/>',
  apps:
    '<rect x="3.5" y="3.5" width="7" height="7" rx="2"/><rect x="13.5" y="3.5" width="7" height="7" rx="2"/>' +
    '<rect x="3.5" y="13.5" width="7" height="7" rx="2"/><rect x="13.5" y="13.5" width="7" height="7" rx="2"/>',
};

/** Standalone markup for one icon. */
export function workspaceIconSvg(id, size = 16) {
  const body = WORKSPACE_ICONS[id];
  if (!body) return '';
  return (
    `<svg viewBox="0 0 24 24" width="${size}" height="${size}" fill="none" stroke="currentColor" ` +
    `stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="display:block">${body}</svg>`
  );
}
